import React from 'react';

import {
  ChevronRightIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import UploadOrChooseFromMediaLibraryModal
  from 'zoomforth_codesbane_editor/component_lib/upload_or_choose_from_media_library_modal.jsx';

const ConfirmCreateHtmlPackageModal = ({
  show,
  shouldShowMediaLibrarySelectionOption,
  onRequestClose,
  onUploadClick,
  onSelectFromMediaLibraryClick
})=> (
  <UploadOrChooseFromMediaLibraryModal
    show={show} 
    shouldShowMediaLibrarySelectionOption={shouldShowMediaLibrarySelectionOption}
    title="Uploading HTML Packages"
    subtitle={(
      <div>
        To add an HTML Package to your site, compress it and upload it as a .zip file.{' '}
        <a 
          target="_blank"
          href="http://support.zoomforth.com/media-library/custom-html-package-guidelines"
        >
          Learn more about HTML Packages on Zoomforth
        </a>

        <ChevronRightIcon />
      </div>
    )}
    uploadFileText="Upload .zip File"
    selectFromMediaLibraryText="Add HTML Package from Media Library"
    onRequestClose={onRequestClose}
    onSelectFromMediaLibraryClick={onSelectFromMediaLibraryClick}
    onUploadClick={onUploadClick}
  />
);

export default ConfirmCreateHtmlPackageModal;
